import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { SharedModule } from 'shared/shared.module';
import { ScrollToService } from 'shared/base/scroll-to.service';
import { SearchPageService } from 'shared/search-page/search-page.service';

import { ReportsRoutingModule } from './reports-routing.module';
import { ReportsComponent } from './reports.component';
/* eslint-disable */
import { ConfigureReportModalComponent } from './components/configure-report-modal/configure-report-modal.component';
import { ReportFiltersComponent} from './components/configure-report-modal/report-filters/report-filters.component';
import { ReportsSearchResultsComponent } from './search/reports-search-results/reports-search-results.component';
import { ReportsSearchResultsRowComponent} from './search/reports-search-results-row/reports-search-results-row.component';
/* eslint-enable */
import { ReportsSearchService } from './search/reports-search.service';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ReportsRoutingModule,
  ],
  declarations: [
    ReportsComponent,
    ReportsSearchResultsComponent,
    ReportsSearchResultsRowComponent,
    ConfigureReportModalComponent,
    ReportFiltersComponent,
  ],
  exports: [ReportsComponent],
  providers: [
    ScrollToService,
    SearchPageService,
    ReportsSearchService,
  ]
})
export class ReportsModule { }
